import { useState } from "react";

import {
  Dialog,
  DialogActionsWrapper,
} from "@/design-system/components/Dialog/Dialog";
import { Button } from "@/design-system/components/Button/Button";
import { User } from "@/components/users/types";

import RoleSelector from "../RoleSelector";

type ChangeUserModalProps = {
  open: boolean;
  onClose: () => void;
  onRoleChange: (role: string) => void;
  defaultRole?: string;
  member: User | null;
};

export function ChangeUserRoleModal({
  open,
  onClose,
  onRoleChange,
  defaultRole,
  member,
}: ChangeUserModalProps) {
  const initialRole = defaultRole ?? "";
  const [selectedRole, setSelectedRole] = useState(initialRole);

  return (
    <Dialog
      onOpenChange={() => {
        onClose();
        setSelectedRole(initialRole);
      }}
      open={open}
      title="Change user role"
      contentProps={{
        className: "w-2xl",
      }}
    >
      <div className="flex flex-col gap-4">
        <div>
          <p className="font-bold" id="email">
            Email
          </p>
          <p>{member?.email}</p>
        </div>
        <RoleSelector
          defaultRole={initialRole}
          onRoleChange={(newRole) => setSelectedRole(newRole)}
        />
      </div>
      <DialogActionsWrapper>
        <Button
          variant="ghost"
          onClick={() => {
            onClose();
            setSelectedRole(initialRole);
          }}
        >
          Close
        </Button>
        <Button
          onClick={() => {
            onRoleChange(selectedRole);
          }}
        >
          Save
        </Button>
      </DialogActionsWrapper>
    </Dialog>
  );
}
